import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
import MainLayout from '@/layouts/main-layout.vue';
import markdownit from 'markdown-it';
import src from './terms.md';
export default /*@__PURE__*/_defineComponent({
  __name: 'Terms',
  setup(__props) {
    const md = markdownit({
      html: true
    });
    const markup = md.render(src);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(MainLayout, null, {
        default: _withCtx(() => [_createElementVNode("section", {
          class: _normalizeClass(_ctx.$style.section),
          innerHTML: _unref(markup)
        }, null, 10, _hoisted_1)]),
        _: 1
      });
    };
  }
});